import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { MailboxFormDefaults } from "@msuite/utils/types";
import { client } from "@/hono";

export function useMailbox(mailboxId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["mailboxes", "mailbox", mailboxId],
		queryFn: async () => {
			const response = await client.mailboxes[":mailboxId"].$get({ param: { mailboxId } });
			const data = await responseHandler(response);
			return data.mailbox as MailboxFormDefaults;
		},
	});

	/** Return */
	return { ...query, mailbox: query.data };
}
